import "@/App.css";
import OTOPage from "@/OTOPage";

function App() {
  return <OTOPage />;
}

export default App;
